module.exports = __webpack_public_path__ + "img/prestat-lavorazioni.b934374a.jpeg";